import { useState } from 'react';
import Timebox from '@/components/common/Calendar/Timebox';
import { convertLocalToWita, convertToLocalTime } from '@/utils';

const DATE_COUNT = 7
const Calendar =
	({
		 startDate,
		 hours,
		 courts,
		 selectedDate,
		 conflictingSchedules,
		 selectedSchedules = {},
		 bookingByCourt,
		 setSelectedDate,
		 setSelectedSchedules,
		 setConflictingSchedules,
		 prices = {},
		 bookingType = '',
		 displayOnly = false,
		 displayCheckbox = false,
		 holiday = false,
		 hideEmptyPrice = false
	} : CalendarProps): JSX.Element => {
	const [selectedField, setSelectedField] = useState([])
	const renderDates = () : JSX.Element[] => {
		const dates = []
		for (let i=0; i<DATE_COUNT; i+=1) {
			const date = new Date(startDate + i * 24 * 60 * 60 * 1000)
			const isDateSelected = new Date(convertToLocalTime(selectedDate)).setHours(0,0,0,0) === date.setHours(0,0,0,0) ?
				'bg-red-primary text-white' :
				'border border-grey-line-subtle'
			const DATE = {
				date: date.getDate(),
				day: new Date(date).toLocaleString('en-us', { weekday: 'short' }),
				month: new Date(date).toLocaleString('en-us', { month: 'short' }),
				time: date.setHours(0,0,0,0)
			}
			dates.push(
				<div className='flex flex-grow flex-col items-center gap-2'>
					<p>{DATE.day}</p>
					<div
						className={`flex flex-col justify-between items-center w-full py-2 gap-1 rounded ${isDateSelected}`}
						onClick={() => {
							// setSelectedDate(convertLocalToWita(DATE.time));
							setSelectedDate(DATE.time)
							setSelectedField([])
							convertLocalToWita(DATE.time)
						}}
						role="button"
						tabIndex={0}
						onKeyDown={() => {}}>
						<p className='font-bold'>{`${DATE.date}`}</p>
						<p>{DATE.month}</p>
					</div>
				</div>
			)
		}
		return dates
	}
	return (
		<div className="w-full">
			<div>
				<div className='flex items-center px-8 py-4 gap-3'>{renderDates()}</div>
			</div>
			<div className='flex justify-around w-full pr-7'>
				<div className='flex justify-around w-full'>
					<div className='flex flex-col items-center basis-1/12 h-full'>
						<div className='h-3'> </div>
						{hours.map(hour => (<div className='h-12 font-medium text-sm text-grey-dark'>{`${hour}.00`}</div>))}
					</div>
					{courts.map(court => (
							<div className='flex flex-col flex-grow h-full basis-1/6'
									 key={court.id}>
								<div className='flex justify-center font-medium text-sm gap-2 accent-red-primary'>
									{displayCheckbox && <>
									<input type='checkbox'
													id={court.id}
													checked={selectedField.includes(court.id) || selectedSchedules[selectedDate]?.filter(schedule => schedule.court.id === court.id).length === 16}
													onChange={() => {
														if (selectedField.includes(court.id)) {
															setSelectedField(selectedField?.filter(field => field !== court.id));
															const payload = { ...selectedSchedules };
															payload[selectedDate] = payload[selectedDate]?.filter(schedule => schedule.court.id !== court.id);
															setSelectedSchedules(payload);
															return;
														}
														setSelectedField([...selectedField, court.id]);
													}} />
										<label htmlFor={court.id}>{`${court.code}`}</label></>}
									{!displayCheckbox && <p>{`${court.code}`}</p>}
								</div>
								{hours.map(hour => (
										<Timebox hour={hour}
												court={court}
												selectedSchedules={selectedSchedules}
												setSelectedSchedules={setSelectedSchedules}
												selectedDate={selectedDate}
												selectedField={selectedField}
												bookedHour={bookingByCourt.find(booking => booking.id === court.id)}
												setSelectedField={setSelectedField}
												conflictingSchedules={conflictingSchedules}
												setConflictingSchedules={setConflictingSchedules}
												prices={prices.length ? prices?.find(price => price.id === court.venue_price_id) : {}}
												bookingType={bookingType}
												displayOnly={displayOnly}
												holiday={holiday}
												hideEmptyPrice={hideEmptyPrice}
										/>
									)
								)}
							</div>
						))}
				</div>
			</div>
		</div>
	);
}

export default Calendar
